import PropTypes from 'prop-types'
import React from 'react'
import { Pagination } from '../Pagination'
import { Select } from '../Select'

import styled from '@emotion/styled'
import tokens from '../../design/tokens'

const StyledPaginationBar = styled.div`
  ${({ $margin }) => ($margin !== undefined ? `margin: ${$margin};` : '')}

  display: flex;
  justify-content: space-between;
  .e-select__selected-item--single {
    font-size: 13px;
    color: ${tokens.color.text.light};
  }
`
const StyledPageNumber = styled.div`
  display: flex;
  align-items: center;
`
const StyledPageSize = styled.div`
  display: flex;
  align-items: center;
  .e-select {
    width: 150px;
  }
`

export const PaginationBar = ({
  pageNumber,
  pageSize,
  totalItems,
  strings,
  minPageSize,
  handleChangePage,
  handleChangePageSize,
  className,
  'data-mu-test': dataAttributeTest,
  margin,
  formatValues,
  sizeSelectOpenUp
}) => {
  return (
    <StyledPaginationBar data-mu-test={dataAttributeTest} $margin={margin}>
      <StyledPageNumber>
        <Pagination
          page={pageNumber}
          pageSize={pageSize}
          totalCount={totalItems}
          onChange={handleChangePage}
          strings={strings}
          className={`${className}-pagination`}
          data-mu-test={`${dataAttributeTest}-pagenumber`}
          formatValues={formatValues}
        />
      </StyledPageNumber>
      {totalItems > minPageSize && (
        <StyledPageSize>
          <Select
            name='pagesize'
            searchable={false}
            value={pageSize}
            options={[5, 10, 20, 50].map(c => ({
              value: c,
              label: `${c} ${strings.label}`
            }))}
            onChange={handleChangePageSize}
            className={`${className}-select`}
            data-mu-test={`${dataAttributeTest}-pagesize`}
            forceOpenUp={sizeSelectOpenUp}
          />
        </StyledPageSize>
      )}
    </StyledPaginationBar>
  )
}

PaginationBar.defaultProps = {
  strings: {
    of: 'of',
    label: 'items'
  },
  minPageSize: 5,
  margin: '20px 0 0 0',
  sizeSelectOpenUp: false
}

PaginationBar.propTypes = {
  pageSize: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  strings: PropTypes.object,
  minPageSize: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangePageSize: PropTypes.func,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  margin: PropTypes.string,
  formatValues: PropTypes.func,
  sizeSelectOpenUp: PropTypes.bool
}
